// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCloseIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M7.073 5.045a1.43 1.43 0 0 0-2.028 0c-.56.561-.56 1.467 0 2.028L9.973 12l-4.928 4.927c-.56.56-.56 1.467 0 2.028.561.56 1.467.56 2.028 0L12 14.028l4.927 4.927a1.433 1.433 0 1 0 2.028-2.028L14.028 12l4.927-4.927a1.44 1.44 0 0 0 0-2.017 1.43 1.43 0 0 0-2.028 0L12 9.973z"
    />
  </g>
);
export default SvgCloseIcon;
SvgCloseIcon.displayName = 'SvgCloseIcon';
